import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { branch, lifecycle, renderComponent } from 'recompose';
import { Loader } from 'semantic-ui-react';
import { selectReady } from './benefits.selectors';
import { EMPLOYER_BENEFITS_LIFECYCLE } from './benefits.types';

export const withDispatchers = connect(null, {
  visit: EMPLOYER_BENEFITS_LIFECYCLE.visit,
  exit: EMPLOYER_BENEFITS_LIFECYCLE.exit,
});

export const withLifecycleActions = lifecycle({
  componentDidMount() {
    this.props.visit(this.props);
  },
  componentWillUnmount() {
    this.props.exit(this.props);
  },
});

const withReadyState = connect(state => ({ ready: selectReady(state) }));

const withLoadingSpinner = branch(
  props => !props.ready,
  renderComponent(() => <Loader active inline="centered" />),
);

export const withInitializer = compose(
  withDispatchers,
  withLifecycleActions,
  withReadyState,
  withLoadingSpinner,
);
